function ageRangeToString(ageRange) {
  const { min, max } = ageRange;
  return max === void 0 ? `${min}+` : min === 0 ? max.toString() : `${min}-${max}`;
}
function ageRangeFromString(input) {
  if (/^\d{1,3}$/.test(input)) {
    return { min: 0, max: Number(input) };
  } else if (/^\d{1,3}\+$/.test(input)) {
    return { min: Number(input.replace("+", "")) };
  } else if (/^\d{1,3}-\d{1,3}$/.test(input)) {
    const [min, max] = input.split("-").map((intStr) => Number(intStr));
    return { min, max };
  }
  return void 0;
}
function ageRangeIncludesRange(opts) {
  const { outer, inner } = opts;
  return outer.min <= inner.min && (outer.max === void 0 || outer.max >= inner.max);
}
function isAdult(ageRange) {
  return ageRange.min >= 20;
}
function calculateNewDemographics(opts) {
  const { entryData, lastEntryIsRepeat, storage, userId } = opts;
  const isFirstEntry = storage.entry.count === 1;
  function getDemographics() {
    if (entryData.$channel === "AD") {
      if (!isFirstEntry || !entryData.$adSetName) {
        return {};
      }
      const { ageRange, gender } = parseDemographicsFromAdSetName(
        entryData.$adSetName
      );
      const adTargetsAllAges = !ageRange || ageRange.min < 20 && (ageRange.max === void 0 || ageRange.max > 20);
      if (adTargetsAllAges) {
        return { gender };
      }
      return {
        ageRange,
        ageConfidence: 70,
        gender
      };
    } else if (entryData.$channel === "CHATBOT") {
      if (lastEntryIsRepeat) {
        return {};
      }
      const { ageRange: newAgeRange, gender: newGender } = parseDemographicsFromPayload(entryData);
      if (!newAgeRange) {
        return { gender: newGender };
      }
      const oldAgeRange = storage.demographics.ageRange;
      if (!oldAgeRange) {
        return { ageConfidence: 80, ageRange: newAgeRange, gender: newGender };
      }
      const payloadRangeContainsExistingRange = ageRangeIncludesRange({
        outer: newAgeRange,
        inner: oldAgeRange
      });
      const existingRangeContainsPayloadRange = ageRangeIncludesRange({
        outer: oldAgeRange,
        inner: newAgeRange
      });
      if (payloadRangeContainsExistingRange && !existingRangeContainsPayloadRange) {
        return { gender: newGender };
      }
      if (existingRangeContainsPayloadRange) {
        const oldAgeConfidence = storage.demographics.ageConfidence || 0;
        const newAgeConfidence = oldAgeConfidence < 80 ? 80 : Math.min(oldAgeConfidence + 10, 99);
        return {
          ageConfidence: newAgeConfidence,
          ageRange: newAgeRange,
          gender: newGender
        };
      }
      return {
        ageConfidence: 50,
        ageRange: newAgeRange,
        gender: newGender
      };
    } else if (entryData.playerID) {
      if (!isFirstEntry || entryData.playerID === userId) {
        return {};
      }
      const { ageConfidence, ageRange } = getReferrerDemographics(entryData);
      if (!ageConfidence || !ageRange) {
        return {};
      }
      if (ageConfidence < 20) {
        return {};
      }
      const payloadTargetsAllAges = ageRange.min < 20 && (ageRange.max === void 0 || ageRange.max > 20);
      if (payloadTargetsAllAges) {
        return {};
      }
      return {
        ageConfidence: Math.ceil(0.6 * ageConfidence),
        ageRange: ageRange.max < 15 ? { min: 0, max: 14 } : ageRange.max < 20 ? { min: 15, max: 19 } : { min: 20, max: 59 }
      };
    }
    return {};
  }
  const demographics = getDemographics();
  if (!demographics.ageRange && isFirstEntry) {
    const { adult, teen } = opts.friendAgeGroupDistribution || {
      adult: 0,
      teen: 0
    };
    if (adult > 0 && teen === 0) {
      return {
        ageConfidence: 40,
        ageRange: { min: 20, max: 59 }
      };
    }
  }
  return demographics;
}
function getReferrerDemographics(entryData) {
  return {
    ageConfidence: entryData.lastEntryAgeConfidence,
    ageRange: entryData.lastEntryAgeRange ? ageRangeFromString(entryData.lastEntryAgeRange) : void 0
  };
}
function parseDemographicsFromAdSetName(adSet) {
  var _a, _b;
  const parsedGender = (_a = adSet.match(/(Male|Female)/g)) == null ? void 0 : _a.pop();
  const gender = parsedGender === "Male" ? "male" : parsedGender === "Female" ? "female" : void 0;
  let ageRange;
  const parsedAgeRange = (_b = adSet.match(/\d{1,3}-\d{1,3}/g)) == null ? void 0 : _b.pop();
  if (parsedAgeRange) {
    const [min, max] = parsedAgeRange.split("-").map((intStr) => Number(intStr));
    ageRange = { min, max };
  }
  return { ageRange, gender };
}
function parseDemographicsFromPayload(payload) {
  const gender = payload.gender === "male" ? "male" : payload.gender === "female" ? "female" : void 0;
  const ageRange = typeof payload.ageRange === "string" ? ageRangeFromString(payload.ageRange) : void 0;
  return { ageRange, gender };
}
export {
  ageRangeToString,
  calculateNewDemographics,
  isAdult,
  parseDemographicsFromAdSetName,
  parseDemographicsFromPayload
};
